import type { ApplicationInsights } from '@microsoft/1ds-analytics-js';
import type { EcsConfigStateSnapshot } from 'owa-analytics-types';
import { retainEcsConfigStateSdkSnapshot } from 'owa-analytics-utils/lib/ecsConfigStateSdkSnapshots';

interface SdkConfigState {
    mapping: EcsConfigStateSnapshot;
    release: () => void;
}

const snapshots = new WeakMap<ApplicationInsights, SdkConfigState>();

export function captureSdkEcsConfigState(
    sdk: ApplicationInsights,
    mapping: EcsConfigStateSnapshot
): void {
    snapshots.get(sdk)?.release();
    const state: SdkConfigState = {
        mapping: { ...mapping },
        release: retainEcsConfigStateSdkSnapshot(mapping),
    };
    snapshots.set(sdk, state);
    sdk.addUnloadCb(() => {
        if (snapshots.get(sdk) === state) {
            state.release();
            snapshots.delete(sdk);
        }
    });
}

export function synchronizeSdkConfigStateLifetime(
    sdk: ApplicationInsights,
    current: EcsConfigStateSnapshot | undefined
): void {
    const state = snapshots.get(sdk);
    if (
        state &&
        current?.accountKey === state.mapping.accountKey &&
        current.lifetimeId > state.mapping.lifetimeId
    ) {
        // Account re-add can reuse an SDK. Retain its actual, immutable tuple,
        // not the newer report's ConfigIds, and never revive an older lifetime.
        state.release();
        state.mapping = { ...state.mapping, lifetimeId: current.lifetimeId };
        state.release = retainEcsConfigStateSdkSnapshot(state.mapping);
    }
}
